module.exports = __webpack_public_path__ + "static/media/mainLogo1.37cda906.png";